import { Injectable } from '@angular/core';
import { CanActivate, CanLoad, Route, UrlSegment, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TermoGuard implements CanActivate, CanLoad {

  constructor(
    private router: Router
  ) {
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot):
    Observable<boolean> | Promise<boolean> | boolean {
    console.log(this.router.url);
    const aceitarTermo = localStorage.getItem('_aceitarTermo');
    if (!aceitarTermo) {
      this.router.navigate(['/termo']);
      return false;
    }
    return true;
  }

  canLoad(route: Route): boolean {
    const aceitarTermo = localStorage.getItem('_aceitarTermo');
    if (!aceitarTermo) {
      this.router.navigate(['/termo']);
      return false;
    }
    return true;
  }
}
